/* Mantiene el aviso de "restantes" sincronizado con el color/variante realmente
   seleccionada. Independiente de theme.min.js a propósito: la app de swatches de
   color (Globo) cambia de variante sin disparar el evento "change" nativo del
   selector, así que en vez de depender de ese evento, este script vigila
   directamente el valor del <select name="id"> del formulario (el mismo valor
   que usa "Agregar al carrito", así que siempre refleja la variante real). */
(function () {
  var lastVals = {};

  function syncStockNotes() {
    document.querySelectorAll(".js-price-stock-note").forEach(function (note) {
      var form = note.closest("form");
      if (!form) return;
      var select = form.querySelector('select[name="id"]');
      if (!select) return;

      var val = select.value;
      var key = select.id || select.name;
      if (lastVals[key] === val) return;
      lastVals[key] = val;

      var option = select.querySelector('option[value="' + val + '"]');
      if (!option || option.disabled) {
        note.style.display = "none";
        return;
      }

      var cap = parseInt(note.getAttribute("data-qty-cap"), 10) || 6;
      var qty = parseInt(option.getAttribute("data-qty"), 10) || 0;
      var span = note.querySelector("span");
      if (span) span.textContent = Math.min(qty, cap);
      note.style.display = "";
    });
  }

  document.addEventListener("DOMContentLoaded", syncStockNotes);
  setInterval(syncStockNotes, 400);
})();
